/* The newsletter popup's trigger, a cached deferred asset since 15/10/2026: until then it was
 * printed inline by sections/newsletter-popup.liquid into every page, where no browser can
 * cache or code-cache it. Its Liquid values now come from the popup's data-nlp-* attributes. */
(function() {
  'use strict';

  /* ============================================================
     NEWSLETTER POPUP TRIGGER
     ============================================================
     Rules:
     - Show after the configured delay.
     - Minimize keeps the popup available; close dismisses it.
     - Auto-minimize after 20 seconds or as soon as the page scrolls.
     - Never on: /cart, /checkout, /account, /orders, thank-you.
     - Never if: user already subscribed, dismissed the popup,
                 or user is mid-action (cart drawer / modal).
     - Exit intent (desktop only): fires after a short grace period
       if the popup has not appeared yet.
     ============================================================ */

  var popup = document.querySelector('newsletter-popup');
  if (!popup) return;

  /* --- 0. Block theme's built-in auto-show ------------------- */
  // The theme's custom element JS loads async, so popup.show()
  // may not exist yet. Instead of intercepting JS, we use a CSS
  // blocker: hide the popup until OUR conditions add [data-nlp-ready].
  // This works regardless of CDN caching or JS load order.

  var _blocker = document.createElement('style');
  _blocker.textContent = 'newsletter-popup:not([data-nlp-ready]) { display: none !important; opacity: 0 !important; pointer-events: none !important; }';
  document.head.appendChild(_blocker);

  var STORAGE_KEYS = {
    shown:       'nlp:shown',           // sessionStorage - "1"
    dismissed:   'nlp:dismissed',       // sessionStorage - "1"
    dismissedPermanent: 'nlp:dismissed-permanent', // localStorage - "1"
    collapsed:   'nlp:collapsed',       // sessionStorage - "1"
    subscribed:  'theme:popup-filled',  // localStorage   - "true"
    appeared:    'theme:popup-appeared', // localStorage   - "true"
    pageViews:   'nlp:pageviews'         // sessionStorage - number
  };

  var NEWSLETTER_IDENTIFY_ENDPOINT = 'https://ski-sises-back-in-stock.onrender.com/apps/intent/newsletter-identify';
  var newsletterContext = {
    shopDomain: popup.getAttribute('data-nlp-shop') || '',
    locale: popup.getAttribute('data-nlp-locale') || '',
    country: popup.getAttribute('data-nlp-country') || '',
    source: 'newsletter_popup_welcome10'
  };
  var newsletterSubmitError = popup.getAttribute('data-nlp-submit-error') || '';
  var newsletterSuccessTitle = popup.getAttribute('data-nlp-success-title') || '';

  /* Welcome or Club (owner, 24/10/2026; sections/newsletter-popup.liquid). data-nlp-club is set only once the
     Ski Sises Club page is live: until then the bubble is the welcome and nothing is asked. Then a visitor who
     already bought sees the Club's news instead: a signed-in customer with orders comes as data-nlp-mode="club";
     a browser is asked once a session, with tracking consent only, while the bubble waits its delay
     (/apps/wishlist/welcome-state answers "club" or "welcome", nothing about the person). WELCOME10 stays valid
     per e-mail: only what the bubble advertises changes. */
  var CLUB_URL = popup.getAttribute('data-nlp-club') || '';
  var CLUB_STATE_ENDPOINT = '/apps/wishlist/welcome-state';
  var CLUB_KEYS = {
    dismissed: 'nlp:club-dismissed',   // localStorage   - "1"
    answer:    'nlp:bubble'            // sessionStorage - "club" | "welcome"
  };
  var CLUB_TIMEOUT_MS = 2500;
  var PRIVACY_WAIT_MS = 3000;
  var bubbleMode = popup.getAttribute('data-nlp-mode') === 'club' ? 'club' : 'welcome';

  var toggleBtn = popup.querySelector('[data-newsletter-popup-toggle]');
  var collapsibleEls = popup.querySelectorAll('[data-newsletter-popup-collapsible]');
  var hasSubmittedSuccessfully = popup.hasAttribute('data-newsletter-popup-submitted');
  var popupShownThisPage = false;
  var pageLoadedAt = Date.now();
  var autoCollapseTimer = null;
  var autoCollapseScrollY = 0;
  var autoCollapseArmedAt = 0;
  var scrollAutoCollapseArmed = false;
  var lastToggleEventAt = 0;
  var newsletterPrewarmStarted = false;

  function getScrollY() {
    return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
  }

  function getNewsletterPageViewCount() {
    var currentCount = parseInt(sessionStorage.getItem(STORAGE_KEYS.pageViews) || '0', 10);

    if (!isFinite(currentCount) || currentCount < 0) {
      currentCount = 0;
    }

    if (!window.__sksNewsletterPageViewCounted) {
      currentCount += 1;
      window.__sksNewsletterPageViewCounted = true;
      sessionStorage.setItem(STORAGE_KEYS.pageViews, String(currentCount));
    }

    return currentCount;
  }

  function isStackElementVisible(element) {
    if (!element || element.hasAttribute('hidden')) return false;

    var style = window.getComputedStyle ? window.getComputedStyle(element) : null;
    if (!style) return true;

    return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
  }

  function isStickyAtcVisible(stickyAtc) {
    if (!isStackElementVisible(stickyAtc)) return false;

    var rect = stickyAtc.getBoundingClientRect();
    if (!rect || rect.width < 1 || rect.height < 1) return false;

    if (stickyAtc.classList && stickyAtc.classList.contains('zrx-sticky-atc-show')) {
      return true;
    }

    return rect.top < window.innerHeight &&
           rect.bottom > 0 &&
           Math.abs(window.innerHeight - rect.bottom) < 8;
  }

  function getProductBrandName() {
    var vendorElement = document.querySelector('.product-info .vendor, a.vendor.h6, .vendor.h6');
    var vendorName = vendorElement ? vendorElement.textContent.trim() : '';

    if (vendorName) return vendorName;

    var jsonLdScripts = document.querySelectorAll('script[type="application/ld+json"]');

    for (var i = 0; i < jsonLdScripts.length; i++) {
      try {
        var parsed = JSON.parse(jsonLdScripts[i].textContent);
        var graph = parsed['@graph'] || parsed;
        var entries = Array.isArray(graph) ? graph : [graph];

        for (var j = 0; j < entries.length; j++) {
          var entry = entries[j];
          if (!entry) continue;

          var type = entry['@type'];
          var isProduct = type === 'Product' || (Array.isArray(type) && type.indexOf('Product') >= 0);
          if (!isProduct) continue;

          var brand = entry.brand || entry.manufacturer;
          if (typeof brand === 'string') return brand;
          if (brand && brand.name) return brand.name;
        }
      } catch (error) {
        // Ignore malformed third-party JSON-LD.
      }
    }

    return '';
  }

  function syncStickyAtcBrand(stickyAtc) {
    if (!stickyAtc) return;

    var brandName = getProductBrandName();
    var titleWrapper = stickyAtc.querySelector('.zrx-sticky-atc-product-title-price-wrapper');

    if (!brandName || !titleWrapper) return;

    var brandElement = titleWrapper.querySelector('.sks-sticky-atc-brand');

    if (!brandElement) {
      brandElement = document.createElement('span');
      brandElement.className = 'sks-sticky-atc-brand';
      titleWrapper.insertBefore(brandElement, titleWrapper.firstChild);
    }

    if (brandElement.textContent !== brandName) {
      brandElement.textContent = brandName;
    }
  }

  function getWhatsAppIconRect() {
    var wrapper = document.querySelector('.whatsapp-chat-btn-wrapper');
    if (!wrapper) return null;

    var wrapperStyle = window.getComputedStyle ? window.getComputedStyle(wrapper) : null;
    if (wrapperStyle && (wrapperStyle.display === 'none' || wrapperStyle.visibility === 'hidden' || wrapperStyle.opacity === '0')) {
      return null;
    }

    var icon = wrapper.querySelector('img, svg, button, a') || wrapper;
    var rect = icon.getBoundingClientRect();

    if (!rect || rect.height < 12 || rect.width < 12) {
      rect = wrapper.getBoundingClientRect();
    }

    if (!rect || rect.height < 12) return null;

    return rect;
  }

  /* The WhatsApp widget controls its own icon geometry, so the bubble is
     centered on the measured icon position instead of mirrored CSS values. */
  function alignCollapsedTeaserToWhatsApp() {
    var shouldAlign = window.innerWidth < 700 &&
                      popup.hasAttribute('data-nlp-ready') &&
                      popup.classList.contains('newsletter-popup--collapsed');

    if (shouldAlign) {
      var iconRect = getWhatsAppIconRect();

      if (iconRect) {
        var bubbleHeight = popup.getBoundingClientRect().height || 56;
        var bottomPx = Math.max(0, Math.round(window.innerHeight - iconRect.bottom + ((iconRect.height - bubbleHeight) / 2)));

        // The popup is pinned at bottom 0 on phones: translate lifts it,
        // and a changed translate is not a layout shift.
        popup.style.setProperty('translate', '0 ' + (-bottomPx) + 'px', 'important');
        return;
      }
    }

    popup.style.removeProperty('translate');
  }

  function syncFloatingStackState() {
    var stickyAtc = document.querySelector('.zrx-sticky-atc-bar');
    syncStickyAtcBrand(stickyAtc);

    // Atelier Alpino (owner, 04/10): the theme's own sticky bar (Prestige's product-sticky-bar, shown with
    // .is-visible) counts as well, now that it replaces Zoorix; assets/luxe.js publishes its height
    var themeStickyBar = document.querySelector('product-sticky-bar');
    document.documentElement.classList.toggle(
      'sks-has-sticky-atc',
      isStickyAtcVisible(stickyAtc) || Boolean(themeStickyBar && themeStickyBar.classList.contains('is-visible'))
    );

    document.documentElement.classList.toggle(
      'sks-has-newsletter-floating',
      popup.hasAttribute('data-nlp-ready') && sessionStorage.getItem(STORAGE_KEYS.dismissed) !== '1'
    );

    alignCollapsedTeaserToWhatsApp();
    syncFloatingDock(themeStickyBar);
  }

  /* On wide screens WhatsApp and the bubble join the row of the product page's sticky bar while it shows (owner,
     29/10/2026, the «Vetro» bar; assets/newsletter-popup.css). For one frame both are hidden while they take their new
     place and shape, then they slide there from where they were with a translate: a changed place in sight is a
     layout shift, a translate is not. */
  var floatingDocked = false;

  function syncFloatingDock(bar) {
    var next = window.innerWidth >= 1000 && Boolean(bar && bar.classList.contains('is-visible'));
    if (next === floatingDocked) return;
    floatingDocked = next;

    var root = document.documentElement;
    var items = [document.querySelector('.whatsapp-chat-btn-wrapper'), popup].filter(Boolean);
    var centre = function(rect) { return [rect.left + rect.width / 2, rect.top + rect.height / 2]; };
    var first = items.map(function(item) { return centre(item.getBoundingClientRect()); });

    root.classList.add('sks-floating-swap');
    root.classList.toggle('sks-floating-docked', next);
    items.forEach(function(item, index) {
      var last = centre(item.getBoundingClientRect());
      item.style.setProperty('--sks-dock-from', Math.round(first[index][0] - last[0]) + 'px ' + Math.round(first[index][1] - last[1]) + 'px');
    });
    root.classList.add('sks-floating-flip');

    // seen again where they were, then on to their place
    requestAnimationFrame(function() {
      root.classList.remove('sks-floating-swap');
      requestAnimationFrame(function() {
        root.classList.remove('sks-floating-flip');
        items.forEach(function(item) { item.style.removeProperty('--sks-dock-from'); });
      });
    });
  }

  var floatingStackStateQueued = false;

  function queueFloatingStackStateSync() {
    if (floatingStackStateQueued) return;
    floatingStackStateQueued = true;

    var sync = function() {
      floatingStackStateQueued = false;
      syncFloatingStackState();
    };

    // After the next paint, not before it (Core Web Vitals, 12/10): the sync measures the WhatsApp icon, a
    // forced layout, and run in the frame of a tap it held back the tap's own response (closing this popup
    // was the second slowest tap on the product pages, by the journey recorder).
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(function() {
        window.setTimeout(sync, 0);
      });
    } else {
      window.setTimeout(sync, 0);
    }
  }

  syncFloatingStackState();
  window.addEventListener('load', syncFloatingStackState);
  window.addEventListener('resize', queueFloatingStackStateSync);
  window.addEventListener('orientationchange', queueFloatingStackStateSync);
  // Atelier Alpino (owner, 04/10): the sticky bar's sizes open above the bar and WhatsApp rises with them
  // (assets/luxe.js); the bubble follows it then too
  document.addEventListener('luxe:floating-stack', queueFloatingStackStateSync);

  // The WhatsApp widget loads late; retry the alignment a few times.
  setTimeout(queueFloatingStackStateSync, 500);
  setTimeout(queueFloatingStackStateSync, 1500);
  setTimeout(queueFloatingStackStateSync, 3500);

  if (typeof MutationObserver !== 'undefined' && document.body) {
    // Atelier Alpino (05/10): only what moves the floating buttons is watched. Watching every class and
    // style change in the page re-measured the WhatsApp icon after each carousel step or widget redraw (about
    // 0.4 s of main thread on a throttled product page). What moves them: the WhatsApp widget arriving or
    // changing, the classes on <html> (the sticky bar's, published by assets/luxe.js, which also announces a
    // change of its height with luxe:floating-stack) and the popup's own state.
    // Atelier Alpino (05/10, Core Web Vitals): of those, only what really moves them. The apps add nodes to
    // <body> all through the load, and <html> takes classes that move nothing (luxe-floating-aside only hides
    // the buttons): each re-measured the WhatsApp icon, a forced layout of 20-50 ms on a throttled phone, 14
    // times on a product page. Now: a node that is or holds the WhatsApp widget, a change of the sticky bar's
    // class on <html>, the popup's state and the widget's own attributes.
    var isWhatsAppNode = function(node) {
      return node.nodeType === 1 && (
        (node.matches && node.matches('.whatsapp-chat-btn-wrapper, .whatsapp-chat-area, [class*="whatsapp-chat"]')) ||
        (node.querySelector && !!node.querySelector('.whatsapp-chat-btn-wrapper'))
      );
    };
    var movesFloatingButtons = function(mutation) {
      if (mutation.type === 'childList') {
        return [].some.call(mutation.addedNodes, isWhatsAppNode) || [].some.call(mutation.removedNodes, isWhatsAppNode);
      }
      if (mutation.target === document.documentElement) {
        var had = (' ' + (mutation.oldValue || '') + ' ').indexOf(' sks-has-sticky-atc ') !== -1;
        return had !== document.documentElement.classList.contains('sks-has-sticky-atc');
      }
      return true;
    };
    var floatingObserver = new MutationObserver(function(mutations) {
      if (!mutations.some(movesFloatingButtons)) return;
      watchWhatsAppWidget();
      queueFloatingStackStateSync();
    });
    var whatsAppWatched = null;
    var watchWhatsAppWidget = function() {
      var widget = document.querySelector('.whatsapp-chat-btn-wrapper');
      if (!widget || widget === whatsAppWatched) return;
      whatsAppWatched = widget;
      floatingObserver.observe(widget, { attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
    };
    floatingObserver.observe(document.body, { childList: true });
    floatingObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'], attributeOldValue: true });
    floatingObserver.observe(popup, { attributes: true, attributeFilter: ['class', 'hidden', 'data-nlp-ready'] });
    watchWhatsAppWidget();
    window.addEventListener('load', watchWhatsAppWidget);
    setTimeout(watchWhatsAppWidget, 1500);
    setTimeout(watchWhatsAppWidget, 3500);
  }

  function closestElement(target, selector) {
    while (target && target !== document) {
      if (target.nodeType === 1 && typeof target.matches === 'function' && target.matches(selector)) {
        return target;
      }

      target = target.parentElement || target.parentNode;
    }

    return null;
  }

  function isNewsletterFormActive() {
    var activeElement = document.activeElement;

    return !!(
      activeElement &&
      popup.contains(activeElement) &&
      closestElement(activeElement, '.newsletter-popup__form')
    );
  }

  function protectNewsletterFormInteraction() {
    popup.setAttribute('data-nlp-form-active', '');
    disarmAutoCollapse();
    prewarmNewsletterEndpoint();
  }

  function handleNewsletterFormInteraction(event) {
    var form = closestElement(event.target, '.newsletter-popup__form');

    if (form && popup.contains(form)) {
      protectNewsletterFormInteraction();
    }
  }

  function getCookie(name) {
    var escapedName = name.replace(/([.*+?^${}()|[\]\\])/g, '\\$1');
    var match = document.cookie.match(new RegExp('(?:^|; )' + escapedName + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function safeStorageGet(storage, key) {
    try {
      return storage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function setNewsletterSubmitting(form, isSubmitting) {
    var submitButton = form.querySelector('[type="submit"]');

    form.toggleAttribute('aria-busy', isSubmitting);
    form.setAttribute('data-newsletter-submitting', isSubmitting ? 'true' : 'false');

    if (submitButton) {
      submitButton.disabled = isSubmitting;
      submitButton.toggleAttribute('aria-busy', isSubmitting);
    }
  }

  function showNewsletterSubmitError(container) {
    var errorElement = container.querySelector('[data-newsletter-popup-submit-error]');

    if (!errorElement) {
      errorElement = document.createElement('div');
      errorElement.className = 'banner banner--error text-center';
      errorElement.setAttribute('data-newsletter-popup-submit-error', '');
      errorElement.setAttribute('role', 'alert');
      container.prepend(errorElement);
    }

    errorElement.textContent = newsletterSubmitError;
    errorElement.hidden = false;
  }

  function readNewsletterPrivacyStatus() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;

    function allowed(name) {
      try {
        return Boolean(privacy && typeof privacy[name] === 'function' && privacy[name]() === true);
      } catch (error) {
        return false;
      }
    }

    return {
      analyticsProcessingAllowed: allowed('analyticsProcessingAllowed'),
      marketingAllowed: allowed('marketingAllowed'),
      preferencesProcessingAllowed: allowed('preferencesProcessingAllowed'),
      saleOfDataAllowed: allowed('saleOfDataAllowed')
    };
  }

  function getNewsletterBrowserContext() {
    var privacy = readNewsletterPrivacyStatus();
    var context = null;

    try {
      context = window.IntegratedProductIntent &&
        typeof window.IntegratedProductIntent.getBrowserContext === 'function'
        ? window.IntegratedProductIntent.getBrowserContext()
        : null;
    } catch (error) {
      context = null;
    }

    if (context && context.customerPrivacyStatus) {
      privacy = context.customerPrivacyStatus;
    }

    var trackingAllowed = privacy.analyticsProcessingAllowed === true || privacy.marketingAllowed === true;

    return {
      visitorId: trackingAllowed ? ((context && context.visitorId) || getCookie('product_intent_visitor_id') || null) : null,
      sessionId: trackingAllowed ? ((context && context.sessionId) || getCookie('product_intent_session_id') || null) : null,
      shopifyClientId: trackingAllowed ? ((context && context.shopifyClientId) || getCookie('_shopify_y') || null) : null,
      customerPrivacyStatus: privacy
    };
  }

  // Where the signup happened (privacy 5.16): the page and its campaign parameters, never the whole
  // address; the site the visitor came from, by host only. It also records where consent was given.
  function getNewsletterSignupPage() {
    var page = { pageUrl: null, referrer: null };
    try {
      var url = new URL(window.location.href);
      var kept = new URLSearchParams();
      ['utm_source', 'utm_medium', 'utm_campaign'].forEach(function (key) {
        var value = url.searchParams.get(key);
        if (value) kept.set(key, value.slice(0, 100));
      });
      var query = kept.toString();
      page.pageUrl = url.origin + url.pathname.slice(0, 200) + (query ? '?' + query : '');
    } catch (_) {}
    try {
      var from = new URL(document.referrer);
      if (from.hostname && from.hostname !== window.location.hostname) page.referrer = from.origin;
    } catch (_) {}
    return page;
  }

  function buildNewsletterPayload(email) {
    var browser = getNewsletterBrowserContext();
    var signupPage = getNewsletterSignupPage();

    return {
      shopDomain: newsletterContext.shopDomain,
      email: email,
      marketingConsent: true,
      analyticsConsent: browser.customerPrivacyStatus.analyticsProcessingAllowed === true,
      customerPrivacyStatus: browser.customerPrivacyStatus,
      visitorId: browser.visitorId,
      shopifyClientId: browser.shopifyClientId,
      sessionId: browser.sessionId,
      locale: newsletterContext.locale,
      country: newsletterContext.country,
      source: newsletterContext.source,
      pageUrl: signupPage.pageUrl,
      referrer: signupPage.referrer
    };
  }

  function prewarmNewsletterEndpoint() {
    if (newsletterPrewarmStarted || typeof fetch !== 'function') return;

    newsletterPrewarmStarted = true;

    try {
      fetch(NEWSLETTER_IDENTIFY_ENDPOINT + '?warmup=1', {
        method: 'GET',
        mode: 'no-cors',
        credentials: 'omit',
        keepalive: true
      }).catch(function() {});
    } catch (error) {}
  }

  function submitNewsletterSignup(email) {
    if (typeof fetch !== 'function') {
      return Promise.resolve();
    }

    return fetch(NEWSLETTER_IDENTIFY_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain' },
      body: JSON.stringify(buildNewsletterPayload(email)),
      credentials: 'omit',
      keepalive: true
    }).then(function(response) {
      return response.json().catch(function() {
        return {};
      }).then(function(body) {
        if (!response.ok || body.success !== true) {
          throw new Error(body.message || 'Newsletter signup failed');
        }

        return body;
      });
    });
  }

  function rememberNewsletterSignup() {
    localStorage.setItem(STORAGE_KEYS.subscribed, 'true');
    localStorage.setItem('nlp:newsletter-subscribed', 'true');
    localStorage.setItem('nlp:newsletter-subscribed-at', new Date().toISOString());
    sessionStorage.setItem(STORAGE_KEYS.shown, '1');
    sessionStorage.removeItem(STORAGE_KEYS.dismissed);
    sessionStorage.removeItem(STORAGE_KEYS.collapsed);
  }

  function ensureSubmittedIntro() {
    var intro = popup.querySelector('.newsletter-popup__intro');
    var formContainer = popup.querySelector('.newsletter-popup__form');
    var title = document.createElement('p');

    if (!intro) {
      intro = document.createElement('div');

      if (formContainer && formContainer.parentNode) {
        formContainer.parentNode.insertBefore(intro, formContainer);
      }
    }

    intro.className = 'newsletter-popup__intro newsletter-popup__intro--success v-stack gap-4 text-center';
    intro.setAttribute('data-newsletter-popup-submitted-intro', '');
    title.className = 'newsletter-popup__title h4';
    title.textContent = newsletterSuccessTitle;
    intro.innerHTML = '';
    intro.appendChild(title);
  }

  function renderNewsletterSuccess(form) {
    var container = closestElement(form, '.newsletter-popup__form') || form.parentElement;
    var template = form.querySelector('[data-newsletter-popup-success-template]');
    var successContent = template ? template.content.cloneNode(true) : null;

    if (container && successContent) {
      container.replaceChildren(successContent);
      ensureSubmittedIntro();
      collapsibleEls = popup.querySelectorAll('[data-newsletter-popup-collapsible]');
    }

    popup.setAttribute('data-newsletter-popup-submitted', '');
    rememberNewsletterSignup();
    setCollapsedState(false);
    showPopup({ restore: true, submitted: true });
  }

  function handleNewsletterSubmit(event) {
    var form = event.target;

    if (!form || !popup.contains(form) || !closestElement(form, '.newsletter-popup__form')) return;
    if (form.getAttribute('data-newsletter-submitting') === 'true') {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }
      return;
    }

    var emailInput = form.querySelector('input[name="contact[email]"], input[type="email"]');
    if (!emailInput) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }
    protectNewsletterFormInteraction();

    if (typeof form.reportValidity === 'function' && !form.reportValidity()) return;

    var email = (emailInput.value || '').trim();
    var container = closestElement(form, '.newsletter-popup__form') || form;
    var existingError = container.querySelector('[data-newsletter-popup-submit-error]');
    if (existingError) existingError.hidden = true;

    setNewsletterSubmitting(form, true);

    renderNewsletterSuccess(form);

    submitNewsletterSignup(email).catch(function(error) {
      console.warn('[newsletter-popup] background signup failed', error);
    });
  }

  function setCollapsedState(isCollapsed) {
    var swap = popup.hasAttribute('data-nlp-ready') &&
               popup.classList.contains('newsletter-popup--collapsed') !== isCollapsed;

    if (swap) popup.classList.add('newsletter-popup--swapping');
    popup.classList.toggle('newsletter-popup--collapsed', isCollapsed);

    if (toggleBtn) {
      toggleBtn.setAttribute('aria-expanded', isCollapsed ? 'false' : 'true');
      toggleBtn.setAttribute('aria-label', isCollapsed ? 'Apri popup newsletter' : 'Riduci popup newsletter');
    }

    collapsibleEls.forEach(function(element) {
      if (isCollapsed) {
        element.setAttribute('hidden', '');
      } else {
        element.removeAttribute('hidden');
      }
    });

    if (isCollapsed) {
      sessionStorage.setItem(STORAGE_KEYS.collapsed, '1');
    } else {
      sessionStorage.removeItem(STORAGE_KEYS.collapsed);
    }

    alignCollapsedTeaserToWhatsApp();

    if (swap) {
      void popup.offsetWidth;
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          popup.classList.remove('newsletter-popup--swapping');
        });
      });
    }
  }

  function disarmAutoCollapse() {
    if (autoCollapseTimer) {
      clearTimeout(autoCollapseTimer);
      autoCollapseTimer = null;
    }

    if (scrollAutoCollapseArmed) {
      window.removeEventListener('scroll', handleAutoCollapseScroll);
      scrollAutoCollapseArmed = false;
    }
  }

  function collapsePopup(reason) {
    if (!popup.hasAttribute('data-nlp-ready')) return;
    if (popup.classList.contains('newsletter-popup--collapsed')) return;
    if ((reason === 'scroll' || reason === 'timer') &&
        (popup.hasAttribute('data-nlp-form-active') || isNewsletterFormActive())) return;

    setCollapsedState(true);
    popup.setAttribute('data-nlp-collapsed-reason', reason || 'manual');
    disarmAutoCollapse();
  }

  function handleAutoCollapseScroll() {
    if (popup.hasAttribute('data-nlp-form-active') || isNewsletterFormActive()) return;
    if (Date.now() - autoCollapseArmedAt < 500) return;
    if (Math.abs(getScrollY() - autoCollapseScrollY) < 16) return;

    collapsePopup('scroll');
  }

  function armAutoCollapse() {
    disarmAutoCollapse();

    if (popup.classList.contains('newsletter-popup--collapsed')) return;
    if (popup.hasAttribute('data-nlp-form-active') || isNewsletterFormActive()) return;

    autoCollapseTimer = setTimeout(function() {
      collapsePopup('timer');
    }, 20000);

    autoCollapseScrollY = getScrollY();
    autoCollapseArmedAt = Date.now();
    scrollAutoCollapseArmed = true;
    window.addEventListener('scroll', handleAutoCollapseScroll, { passive: true });
  }

  function markDismissed() {
    sessionStorage.setItem(STORAGE_KEYS.dismissed, '1');
    sessionStorage.setItem(STORAGE_KEYS.shown, '1');
    sessionStorage.removeItem(STORAGE_KEYS.collapsed);
    disarmAutoCollapse();
    queueFloatingStackStateSync();

    if (bubbleMode === 'club') {
      localStorage.setItem(CLUB_KEYS.dismissed, '1');
    } else if (popup.hasAttribute('only-once')) {
      localStorage.setItem(STORAGE_KEYS.dismissedPermanent, '1');
    }
  }

  function handleNewsletterControls(event) {
    var target = event.target;

    if (!target) return;

    var currentToggleBtn = closestElement(target, '[data-newsletter-popup-toggle]');
    if (currentToggleBtn && popup.contains(currentToggleBtn)) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }

      if (Date.now() - lastToggleEventAt < 350) return;
      lastToggleEventAt = Date.now();

      if (popup.classList.contains('newsletter-popup--collapsed')) {
        popup.removeAttribute('data-nlp-collapsed-reason');
        setCollapsedState(false);
        armAutoCollapse();
      } else {
        collapsePopup('manual');
      }

      return;
    }

    // Close means "dismiss completely"; minimize keeps the popup available.
    var currentCloseBtn = closestElement(target, 'newsletter-popup .pop-in__close-button');
    if (currentCloseBtn) {
      markDismissed();
    }
  }

  document.addEventListener('pointerup', handleNewsletterControls, true);
  document.addEventListener('click', handleNewsletterControls, true);
  popup.addEventListener('focusin', handleNewsletterFormInteraction, true);
  popup.addEventListener('pointerdown', handleNewsletterFormInteraction, true);
  popup.addEventListener('click', handleNewsletterFormInteraction, true);
  popup.addEventListener('input', handleNewsletterFormInteraction, true);
  popup.addEventListener('submit', handleNewsletterFormInteraction, true);
  popup.addEventListener('submit', handleNewsletterSubmit, true);

  if (hasSubmittedSuccessfully) {
    rememberNewsletterSignup();
    ensureSubmittedIntro();
    showPopup({ restore: true, submitted: true });
    return;
  }

  /* --- 1. Welcome or Club ----------------------------------- */

  function applyClubMode() {
    var club = popup.querySelector('[data-nlp-club-content]');
    if (!club) return;   // no Club markup: the welcome stays
    bubbleMode = 'club';
    popup.setAttribute('data-nlp-mode', 'club');
    var clubTitle = club.querySelector('.newsletter-popup__title');
    if (clubTitle && clubTitle.firstChild) popup.setAttribute('aria-label', clubTitle.firstChild.textContent.trim());
    popup.querySelectorAll('.newsletter-popup__intro, .newsletter-popup__form').forEach(function(element) {
      element.setAttribute('hidden', '');
    });
    club.removeAttribute('hidden');
    // minimizing now folds the Club's news under its title (the bar on wider screens); the newsletter's parts stay hidden
    collapsibleEls = [club.querySelector('[data-nlp-club-body]') || club];
    var teaser = popup.querySelector('[data-nlp-teaser]');
    if (teaser) teaser.textContent = 'Club';
    var me = club.querySelector('[data-nlp-club-me]');
    if (me) showClubMe(me, club.querySelector('[data-nlp-club-coupon]'), club);
    var login = club.querySelector('[data-nlp-club-login]');
    if (login) keepSignInReachable(login, club.querySelector('[data-nlp-club-login-fallback]'));
  }

  // Signed in: "Sei Club: hai 450 punti, pari a 22,50 €. Ti mancano 180 € per Select." from the club's own
  // summary (the text that says what the club is stays when it does not answer), the code for the checkout and
  // its amount in the minimized bubble.
  function clubJson(url, options) {
    return fetch(url, Object.assign({ credentials: 'same-origin', headers: { Accept: 'application/json' } }, options || {}))
      .then(function(response) {
        return response.json().catch(function() { return null; }).then(function(body) {
          return response.ok ? body : (body && body.success === false ? body : null);
        });
      })
      .catch(function() { return null; });
  }

  function clubFormat(element) {
    var locale = element.getAttribute('data-locale') || undefined;
    var currency = element.getAttribute('data-currency') || 'EUR';
    return {
      number: function(value) {
        try { return new Intl.NumberFormat(locale).format(value); } catch (error) { return String(value); }
      },
      money: function(cents) {
        // whole amounts without decimals: "20 €", "22,50 €"
        var digits = cents % 100 === 0 ? 0 : 2;
        try {
          return new Intl.NumberFormat(locale, { style: 'currency', currency: currency,
            minimumFractionDigits: digits, maximumFractionDigits: digits }).format(cents / 100);
        } catch (error) {
          return (cents / 100).toFixed(2) + ' ' + currency;
        }
      },
      percent: function(bps) {
        try { return new Intl.NumberFormat(locale, { style: 'percent', maximumFractionDigits: 1 }).format(bps / 10000); }
        catch (error) { return (bps / 100) + '%'; }
      },
      // a day of Rome's calendar: "12 novembre"
      day: function(iso) {
        try { return new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'long', timeZone: 'Europe/Rome' }).format(new Date(iso)); }
        catch (error) { return String(iso).slice(0, 10); }
      }
    };
  }

  function writeClubBalance(element, summary, format) {
    var text = (element.getAttribute('data-balance') || '')
      .replace('%TIER%', summary.tier)
      .replace('%POINTS%', format.number(Number(summary.availablePoints) || 0))
      .replace('%VALUE%', format.money(Number(summary.availableValueCents) || 0));
    if (summary.nextTier && Number(summary.amountToNextTierCents) > 0) {
      text += ' ' + (element.getAttribute('data-next') || '')
        .replace('%AMOUNT%', format.money(Number(summary.amountToNextTierCents)))
        .replace('%TIER%', summary.nextTier);
    }
    if (text.trim()) element.textContent = text.trim();
  }

  // The bubble, minimized, says what the code is worth: "-20€" in the round bubble, «Ski Sises Club · -20€» in the bar
  function showClubTeaser(text) {
    var teaser = popup.querySelector('[data-nlp-teaser]');
    if (teaser) teaser.textContent = text;
    var amount = popup.querySelector('[data-nlp-club-amount]');
    if (amount) {
      amount.textContent = ' \u00b7 ' + text;
      amount.removeAttribute('hidden');
    }
  }

  function showClubAmount(cents) {
    if (cents > 0) showClubTeaser('-' + Math.floor(cents / 100) + '\u20ac');
  }

  // The most valuable code still usable, else none
  function activeClubCoupon(summary) {
    var now = Date.now();
    var codes = (summary.coupons || []).filter(function(coupon) {
      return coupon && coupon.status === 'active' && coupon.shopifyDiscountCode &&
        !(coupon.expiresAt && Date.parse(coupon.expiresAt) <= now);
    });
    codes.sort(function(a, b) { return (Number(b.couponValueCents) || 0) - (Number(a.couponValueCents) || 0); });
    return codes[0] || null;
  }

  // All the points, in whole euros (owner, 28/10/2026: «possa creare coupon con il massimo»), from the club's smallest
  // code on (5 € today), else 0: a code larger than the cart allows is divided at the checkout
  function largestClubCoupon(summary, settings) {
    var available = Math.floor((Number(summary.availableValueCents) || 0) / 100) * 100;
    var values = ((settings && settings.couponDenominationsCents) || [500]).map(Number).filter(function(value) { return value > 0; });
    var smallest = values.length ? Math.min.apply(null, values) : 500;
    return available >= smallest ? available : 0;
  }

  // The checkout with a club code (owner, 28/10/2026: «diviso al checkout»): on the way to the checkout, never while
  // the cart is being filled, the member is asked to use the code. A code larger than the cart's 10% of full-price
  // products is divided: the part the cart takes now and a new code with the rest (the club's /checkout route).
  // «No» goes on without the code, Esc stays in the cart. The code rides to the checkout as Shopify's /discount link
  // sets it; anything that fails lets the checkout go on as the member asked.
  var clubCheckout = null;
  var clubCheckoutPassing = false;

  function clubCartLines() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        var lines = (cart.items || []).map(function(item) {
          return { productId: item.product_id, variantId: item.variant_id, quantity: item.quantity, priceCents: item.final_price,
                   compareAtPriceCents: item.original_price > item.final_price ? item.original_price : null, productTags: [] };
        });
        // a code the bag already applies (a Club code the bag fitted, assets/luxe.js): nothing to ask at the checkout
        lines.holdsCode = (cart.discount_codes || []).some(function(entry) { return entry.applicable; });
        return lines;
      });
  }

  function askClubCheckout(answer, done) {
    var box = clubCheckout.box;
    var money = clubCheckout.format.money;
    var dialog = document.createElement('dialog');
    dialog.className = 'newsletter-popup__checkout';
    var text = document.createElement('p');
    text.textContent = answer.action === 'apply'
      ? (box.getAttribute('data-checkout-use') || '').replace('%AMOUNT%', money(answer.now.valueCents))
      : (box.getAttribute('data-checkout-split') || '').replace('%NOW%', money(answer.now.valueCents))
        .replace('%AMOUNT%', money(Number(clubCheckout.coupon.couponValueCents) || 0)).replace('%LATER%', money(answer.later.valueCents));
    var yes = document.createElement('button');
    yes.type = 'button';
    yes.className = 'button w-full';
    yes.textContent = (box.getAttribute('data-checkout-yes') || '').replace('%AMOUNT%', money(answer.now.valueCents));
    var no = document.createElement('button');
    no.type = 'button';
    no.className = 'button button--outline w-full';
    no.textContent = box.getAttribute('data-checkout-no') || '';
    dialog.append(text, yes, no);
    yes.addEventListener('click', function() {
      yes.disabled = no.disabled = true;
      yes.setAttribute('aria-busy', 'true');
      done(true);
    });
    no.addEventListener('click', function() {
      dialog.close();
      dialog.remove();
      done(false);
    });
    dialog.addEventListener('cancel', function() { dialog.remove(); });
    document.body.appendChild(dialog);
    dialog.showModal();
  }

  function onClubCheckout(event) {
    var submitter = event.submitter;
    if (!clubCheckout || clubCheckoutPassing || !submitter || submitter.name !== 'checkout') return;
    var form = event.target;
    event.preventDefault();
    event.stopImmediatePropagation();
    var go = function(code) {
      var next = function() {
        clubCheckoutPassing = true;
        if (form.requestSubmit) form.requestSubmit(submitter);
        else form.submit();
      };
      if (!code) return next();
      fetch('/discount/' + encodeURIComponent(code) + '?redirect=%2Fcart.js', { credentials: 'same-origin' }).then(next, next);
    };
    clubCartLines().then(function(lines) { return askClubForLines(lines, go); }).catch(function() { go(null); });
  }

  // The question for these lines, then go(code): the code to use, or null to go on without one
  function askClubForLines(lines, go) {
    if (lines.holdsCode) return go(null);
    var code = clubCheckout.coupon.shopifyDiscountCode;
    var post = function(confirm) {
      return clubJson('/apps/wishlist/loyalty/checkout', {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ code: code, lines: lines, confirm: confirm })
      });
    };
    return post(false).then(function(answer) {
      if (!answer || answer.success !== true || answer.action === 'none' || !answer.now) return go(null);
      askClubCheckout(answer, function(yes) {
        if (!yes) return go(null);
        if (answer.action === 'apply') return go(answer.now.code);
        post(true).then(function(done) { go(done && done.success === true && done.now ? done.now.code : null); });
      });
    });
  }

  // «Acquista ora» on the product page (owner, 28/10/2026): Shopify's button (Shop Pay, «Altre opzioni di pagamento»)
  // leaves for a checkout of this product alone and never meets the question above, so a code larger than the product
  // allows was refused there. For a member with a code, on a product of the Club (the rule of the server and of the
  // app's widget: eligibilityFromShopifyNode), its click asks the same question for the bag with this product, then
  // the product goes into the bag and the bag to the checkout, with the code or without it; Shopify's checkout offers
  // Shop Pay again. Shop Pay's own button sits in a closed shadow root and cannot be pressed again for the member, and
  // a cart link (/cart/<variant>:<quantity>) would empty the bag (checked live, 28/10/2026). Esc changes nothing.
  function clubBuyNowLine(form) {
    var data = document.getElementById('BackInStockProductJson');
    var product = null;
    try { product = data ? JSON.parse(data.textContent) : null; } catch (error) { product = null; }
    var id = form && form.elements.namedItem('id');
    if (!product || !id || !id.value) return null;
    var variant = (product.variants || []).filter(function(row) { return String(row.id) === String(id.value); })[0];
    if (!variant) return null;
    var tags = (product.productTags || []).map(function(tag) { return String(tag).toLowerCase(); });
    var yes = function(value) { return value === true || value === 'true'; };
    var fullPrice = !variant.compareAtPriceCents || Number(variant.compareAtPriceCents) <= Number(variant.priceCents || 0);
    var excluded = tags.some(function(tag) { return ['outlet', 'sale', 'loyalty_excluded'].indexOf(tag) !== -1; });
    var club = yes(product.productLoyaltyEligible) || yes(variant.loyaltyEligible) ||
      tags.indexOf('coupon_on') !== -1 || tags.indexOf('loyalty_eligible') !== -1;
    if (!fullPrice || excluded || !club) return null;
    // the quantity picker may sit outside the form
    var quantity = form.elements.namedItem('quantity') || (form.closest('section') || document).querySelector('[name="quantity"]');
    return { productId: product.productId, variantId: Number(variant.id), quantity: Math.max(1, parseInt(quantity && quantity.value, 10) || 1),
             priceCents: Number(variant.priceCents) || 0, compareAtPriceCents: variant.compareAtPriceCents || null, productTags: product.productTags || [] };
  }

  function onClubBuyNow(event) {
    if (!clubCheckout || clubCheckoutPassing || !(event.target instanceof Element)) return;
    var area = event.target.closest('[data-shopify="payment-button"]');
    var line = area ? clubBuyNowLine(area.closest('form')) : null;
    if (!line) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var go = function(code) {
      clubCheckoutPassing = true;
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: line.variantId, quantity: line.quantity }] })
      }).then(function(response) {
        // not added (no stock for that quantity): the bag says why
        if (!response.ok) { window.location.href = '/cart'; return; }
        var checkout = function() { window.location.href = '/checkout'; };
        if (!code) return checkout();
        fetch('/discount/' + encodeURIComponent(code) + '?redirect=%2Fcart.js', { credentials: 'same-origin' }).then(checkout, checkout);
      }, function() { window.location.href = '/cart'; });
    };
    clubCartLines().then(function(lines) {
      var all = lines.concat([line]);
      all.holdsCode = lines.holdsCode;
      return askClubForLines(all, go);
    }).catch(function() { go(null); });
  }

  function showClubCode(box, coupon, format) {
    var label = document.createElement('span');
    label.className = 'text-xs bold';
    label.textContent = box.getAttribute('data-code-label') || '';
    var code = document.createElement('strong');
    code.className = 'newsletter-popup__discount-code';
    code.tabIndex = 0;
    code.textContent = coupon.shopifyDiscountCode;
    var holder = document.createElement('div');
    holder.className = 'newsletter-popup__success-code v-stack gap-2';
    holder.appendChild(label);
    holder.appendChild(code);
    // the club's cap: the code asks Shopify for this much of full-price products
    var rule = document.createElement('p');
    rule.className = 'text-xs';
    rule.textContent = (box.getAttribute('data-from') || '') + ' ' + format.money(Number(coupon.minEligibleSubtotalCents) || 0);
    var copy = document.createElement('copy-button');
    copy.setAttribute('data-text', coupon.shopifyDiscountCode);
    copy.setAttribute('data-success-message', box.getAttribute('data-copied') || '');
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'button w-full';
    button.textContent = box.getAttribute('data-copy') || '';
    copy.appendChild(button);
    box.replaceChildren(holder, rule, copy);
    box.removeAttribute('hidden');
    showClubAmount(Number(coupon.couponValueCents) || 0);
  }

  // The birthday's code while it works (owner, 27/10/2026), else none
  function birthdayClubCode(summary) {
    var code = summary.birthdayCode;
    var now = Date.now();
    if (!code || code.used || !code.code) return null;
    if (code.startsAt && Date.parse(code.startsAt) > now) return null;
    if (code.endsAt && Date.parse(code.endsAt) <= now) return null;
    return code;
  }

  // Its own place, above the points' code: «Il tuo regalo di compleanno», the code, «15% sui prodotti non scontati ·
  // valido fino al 12 novembre», «Copia codice»
  function showBirthdayCode(box, code, format) {
    var label = document.createElement('span');
    label.className = 'text-xs bold';
    label.textContent = box.getAttribute('data-label') || '';
    var text = document.createElement('strong');
    text.className = 'newsletter-popup__discount-code';
    text.tabIndex = 0;
    text.textContent = code.code;
    var holder = document.createElement('div');
    holder.className = 'newsletter-popup__success-code v-stack gap-2';
    holder.appendChild(label);
    holder.appendChild(text);
    var rule = document.createElement('p');
    rule.className = 'text-xs';
    rule.textContent = (box.getAttribute('data-rule') || '')
      .replace('%PERCENT%', format.percent(Number(code.percentBps) || 0))
      .replace('%DATE%', code.endsAt ? format.day(code.endsAt) : '');
    var copy = document.createElement('copy-button');
    copy.setAttribute('data-text', code.code);
    copy.setAttribute('data-success-message', box.getAttribute('data-copied') || '');
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'button w-full';
    button.textContent = box.getAttribute('data-copy') || '';
    copy.appendChild(button);
    box.replaceChildren(holder, rule, copy);
    box.removeAttribute('hidden');
  }

  function offerClubCode(box, cents, settings, format, element) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'button w-full';
    button.textContent = (box.getAttribute('data-create') || '').replace('%AMOUNT%', format.money(cents));
    button.addEventListener('click', function() {
      if (button.disabled) return;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      // spent only on this click; the code asks Shopify for ten times its value of full-price products (10% cap)
      var bps = Number(settings && settings.maxDiscountBps) || 1000;
      clubJson('/apps/wishlist/loyalty/redeem', {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ couponValueCents: cents, eligibleSubtotalCents: Math.ceil(cents * 10000 / bps) })
      }).then(function(body) {
        if (!body || body.success !== true || !body.couponCode) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
          return;
        }
        showClubCode(box, { shopifyDiscountCode: body.couponCode, couponValueCents: cents,
                            minEligibleSubtotalCents: body.minEligibleSubtotalCents }, format);
        // the points just spent: the balance again
        clubJson('/apps/wishlist/loyalty/me').then(function(me) {
          if (me && me.authenticated && me.summary && me.summary.tier) writeClubBalance(element, me.summary, format);
        });
      });
    });
    box.replaceChildren(button);
    box.removeAttribute('hidden');
    showClubAmount(cents);
  }

  function showClubMe(element, box, club) {
    if (typeof fetch !== 'function') return;
    Promise.all([clubJson('/apps/wishlist/loyalty/me'), clubJson('/apps/wishlist/loyalty/settings')]).then(function(answers) {
      var me = answers[0];
      var settings = answers[1];
      var summary = me && me.authenticated && me.summary;
      if (!summary || !summary.tier) return;
      var format = clubFormat(element);
      writeClubBalance(element, summary, format);
      var birthday = birthdayClubCode(summary);
      var birthdayBox = birthday && club ? club.querySelector('[data-nlp-club-birthday]') : null;
      if (birthdayBox) showBirthdayCode(birthdayBox, birthday, format);
      if (box) {
        var coupon = activeClubCoupon(summary);
        var cents = coupon || !(settings && settings.visible !== false) ? 0 : largestClubCoupon(summary, settings);
        if (coupon) showClubCode(box, coupon, format);
        if (coupon && settings && settings.visible !== false) {
          clubCheckout = { coupon: coupon, box: box, format: format };
          document.addEventListener('submit', onClubCheckout, true);
          document.addEventListener('click', onClubBuyNow, true);
        }
        else if (cents > 0) offerClubCode(box, cents, settings, format, element);
      }
      if (!birthdayBox) return;
      // the minimized bubble says the birthday's «-15%»; codes never add up, said when the points' code shows too
      showClubTeaser('-' + format.percent(Number(birthday.percentBps) || 0).replace(/\s/g, ''));
      var single = club.querySelector('[data-nlp-club-single]');
      if (single && box && !box.hidden) single.removeAttribute('hidden');
    });
  }

  // Shopify's account component signs in without leaving the page; when its script does not arrive the
  // plain link to the sign-in page takes its place.
  function keepSignInReachable(component, fallback) {
    if (!fallback || !window.customElements) return;
    var swap = function() {
      if (window.customElements.get('shopify-account')) return;
      component.setAttribute('hidden', '');
      fallback.removeAttribute('hidden');
    };
    setTimeout(swap, 4000);
  }

  // The Customer Privacy API arrives with Shopify's own scripts: wait for it a little, never past the delay's use.
  function whenPrivacyReady() {
    return new Promise(function(resolve) {
      var waited = 0;
      (function check() {
        var api = window.Shopify && window.Shopify.customerPrivacy;
        if ((api && typeof api.analyticsProcessingAllowed === 'function') || waited >= PRIVACY_WAIT_MS) {
          resolve();
          return;
        }
        waited += 250;
        setTimeout(check, 250);
      })();
    });
  }

  function askBubble() {
    var cached = safeStorageGet(sessionStorage, CLUB_KEYS.answer);
    if (cached === 'club' || cached === 'welcome') return Promise.resolve(cached);
    var browser = getNewsletterBrowserContext();   // the visitor id only with tracking consent
    if (!browser.visitorId || typeof fetch !== 'function') return Promise.resolve('welcome');
    var privacy = browser.customerPrivacyStatus || {};
    var params = new URLSearchParams({
      a: privacy.analyticsProcessingAllowed === true ? '1' : '0',
      m: privacy.marketingAllowed === true ? '1' : '0',
      v: String(browser.visitorId)
    });
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = setTimeout(function() { if (controller) controller.abort(); }, CLUB_TIMEOUT_MS);
    return fetch(CLUB_STATE_ENDPOINT + '?' + params.toString(), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      signal: controller ? controller.signal : undefined
    }).then(function(response) {
      return response.ok ? response.json() : {};
    }).then(function(body) {
      var answer = body && body.bubble === 'club' ? 'club' : 'welcome';
      if (body && body.success === true) {
        try { sessionStorage.setItem(CLUB_KEYS.answer, answer); } catch (error) { /* private mode */ }
      }
      return answer;
    }).catch(function() {
      return 'welcome';
    }).then(function(answer) {
      clearTimeout(timer);
      return answer;
    });
  }

  function decideBubble() {
    if (bubbleMode === 'club' || !CLUB_URL) return Promise.resolve(bubbleMode);
    return whenPrivacyReady().then(askBubble);
  }

  function showPopup(options) {
    options = options || {};

    // The stylesheet loads without blocking the page (media="print" until it arrives): never
    // show the popup unstyled.
    var sheet = document.getElementById('sks-newsletter-popup-css');
    if (sheet && sheet.media !== 'all') {
      sheet.addEventListener('load', function() { showPopup(options); }, { once: true });
      return;
    }

    // Final safety checks right before showing
    if (!options.restore && popupShownThisPage) return;

    // Don't interrupt if cart drawer is open or user is mid-action
    var cartDrawer = document.querySelector('cart-drawer[open], .cart-drawer[open]');
    var anyModal = document.querySelector('.modal[open], dialog[open]');
    if (options.submitted !== true && (cartDrawer || anyModal)) {
      // Retry after 5 seconds
      setTimeout(function() {
        showPopup(options);
      }, 5000);
      return;
    }

    // Remove CSS blocker and show
    if (bubbleMode !== 'club') prewarmNewsletterEndpoint();
    popup.setAttribute('data-nlp-ready', '');

    setCollapsedState(options.collapsed === true);
    if (options.submitted === true) {
      popup.setAttribute('data-newsletter-popup-submitted', '');
    }
    syncFloatingStackState();

    function openWhenReady() {
      if (typeof popup.show !== 'function') {
        setTimeout(openWhenReady, 150);
        return;
      }

      popup.show();
      popupShownThisPage = true;
      sessionStorage.setItem(STORAGE_KEYS.shown, '1');
      localStorage.setItem(STORAGE_KEYS.appeared, 'true');

      if (options.submitted === true) {
        localStorage.setItem(STORAGE_KEYS.subscribed, 'true');
        sessionStorage.removeItem(STORAGE_KEYS.collapsed);
        disarmAutoCollapse();
      } else {
        armAutoCollapse();
      }
    }

    if (window.customElements && typeof window.customElements.whenDefined === 'function') {
      window.customElements.whenDefined('newsletter-popup').then(openWhenReady);
    } else {
      openWhenReady();
    }
  }

  function startBubble(mode, elapsed) {
    if (mode === 'club') applyClubMode();
    var club = bubbleMode === 'club';

    /* --- 2. Early exits -------------------------------------- */

    if (club) {
      // The Club's news, closed once, stays closed
      if (safeStorageGet(localStorage, CLUB_KEYS.dismissed) === '1') return;
    } else {
      // Already subscribed (persisted across sessions)
      if (localStorage.getItem(STORAGE_KEYS.subscribed) === 'true') return;

      // Fully dismissed before, only when the section is configured as only-once
      if (popup.hasAttribute('only-once') &&
          localStorage.getItem(STORAGE_KEYS.dismissedPermanent) === '1') return;
    }

    // Fully dismissed this session
    if (sessionStorage.getItem(STORAGE_KEYS.dismissed) === '1') return;

    /* --- 3. URL-based exclusions (client-side safety net) ---- */

    var path = window.location.pathname.toLowerCase();
    var excludedPaths = ['/cart', '/checkout', '/account', '/orders', '/challenge'];
    for (var i = 0; i < excludedPaths.length; i++) {
      if (path.indexOf(excludedPaths[i]) === 0) return;
    }
    // Shopify thank-you / order-status pages
    if (path.indexOf('/thank_you') >= 0 || path.indexOf('/order') >= 0) return;

    // Keep the minimized popup available across pageviews until it is closed.
    if (sessionStorage.getItem(STORAGE_KEYS.shown) === '1' &&
        sessionStorage.getItem(STORAGE_KEYS.collapsed) === '1') {
      showPopup({ restore: true, collapsed: true });
      return;
    }

    /* --- 4. Device detection --------------------------------- */

    var isMobile = window.innerWidth < 700 ||
                   ('ontouchstart' in window && navigator.maxTouchPoints > 1);

    /* --- 5. Show popup with delay ---------------------------- */

    // The question ran during the delay: only what is left of it is waited.
    var showDelay = parseInt(popup.getAttribute('data-nlp-delay'), 10) || 0;
    setTimeout(showPopup, Math.max(0, showDelay - (elapsed || 0)));

    /* --- 6. Exit intent (desktop only) ----------------------- */

    if (!isMobile) {
      var exitIntentFired = false;

      document.addEventListener('mouseout', function(e) {
        if (exitIntentFired) return;
        if (popupShownThisPage) return;

        // Only trigger when mouse leaves through the top of the viewport
        if (e.clientY > 10) return;
        if (e.relatedTarget || e.toElement) return;

        // Only after a short grace period, so it does not flash immediately.
        if (Date.now() - pageLoadedAt < 5000) return;

        exitIntentFired = true;
        showPopup();
      });
    }
  }

  var bubbleAskedAt = Date.now();
  decideBubble().then(function(mode) {
    startBubble(mode, Date.now() - bubbleAskedAt);
  });

})();
